import { VStack } from '@bpba/ui-components';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FormChildProps } from '../../types/FormChildProps';
import { IndexValue } from '../../types/IndexValue';
import { StyledButton } from '../shared/StyledButton';

export type FormProps = {
  controls?: React.ReactNode;
  cantMaxima?: number;
  textoBoton: string;
  reset: boolean | undefined;
  callback: (data: any | any[]) => void;
  children: ((props: FormChildProps) => React.ReactNode)[];
};

export const TemplateForm = (props: FormProps) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<IndexValue>({ mode: 'onBlur' });

  useEffect(() => {
    if (props.reset && props.cantMaxima)
      for (let i = props.children.length + 1; i <= props.cantMaxima; i++) {
        reset({ ['dni' + i]: null, ['nombre' + i]: null, ['email' + i]: null });
      }
  }, [props.children.length, props.cantMaxima, props.reset, reset]);

  const sendData = (data: IndexValue) => {
    props.callback(data);
  };

  return (
    <form onSubmit={handleSubmit(sendData)}>
      <VStack alignItems="end" color={'white'}>
        {props.children &&
          props.children.map((item, index) => {
            return (
              <VStack key={index}>
                {item({ register: register, errors: errors, index: index + 1, indexed: props.children.length > 1 ? true : false })}
              </VStack>
            );
          })}
        {props.controls && props.controls}
        <StyledButton marginTop={'30px'} width={['fit-content']}>
          {props.textoBoton}
        </StyledButton>
      </VStack>
    </form>
  );
};
